
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/49d1abc2-a37b-4afb-b4e8-ea68424b7823.png" 
            alt="BitFlow Logo" 
            className="h-10 md:h-12"
          />
        </div>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          <a 
            href="#about" 
            onClick={(e) => { e.preventDefault(); scrollToSection('about'); }} 
            className={`transition-colors cursor-pointer font-medium ${
              scrolled ? 'text-[#162840]/80 hover:text-[#72BF3B]' : 'text-[#162840]/80 hover:text-[#72BF3B]'
            }`}
          >
            Sobre
          </a>
          <a 
            href="#features" 
            onClick={(e) => { e.preventDefault(); scrollToSection('features'); }} 
            className={`transition-colors cursor-pointer font-medium ${
              scrolled ? 'text-[#162840]/80 hover:text-[#72BF3B]' : 'text-[#162840]/80 hover:text-[#72BF3B]'
            }`}
          >
            Soluções
          </a>
          <a 
            href="#bitrix" 
            onClick={(e) => { e.preventDefault(); scrollToSection('bitrix'); }} 
            className={`transition-colors cursor-pointer font-medium ${
              scrolled ? 'text-[#162840]/80 hover:text-[#72BF3B]' : 'text-[#162840]/80 hover:text-[#72BF3B]'
            }`}
          >
            Bitrix24
          </a>
          <a 
            href="#contact" 
            onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} 
            className="bg-[#72BF3B] text-white px-6 py-3 rounded-xl hover:bg-[#99D93B] transition-all shadow-lg hover:shadow-xl cursor-pointer font-semibold whitespace-nowrap"
          >
            Fale Conosco
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-[#162840] cursor-pointer"
        >
          <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-300 overflow-hidden ${
        mobileMenuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="bg-white/95 backdrop-blur-md px-6 py-4 space-y-4 border-t border-gray-100">
          <a 
            href="#about" 
            onClick={(e) => { e.preventDefault(); scrollToSection('about'); }} 
            className="block text-[#162840]/80 hover:text-[#72BF3B] transition-colors cursor-pointer font-medium py-2"
          >
            Sobre
          </a>
          <a 
            href="#features" 
            onClick={(e) => { e.preventDefault(); scrollToSection('features'); }} 
            className="block text-[#162840]/80 hover:text-[#72BF3B] transition-colors cursor-pointer font-medium py-2"
          >
            Soluções
          </a>
          <a 
            href="#bitrix" 
            onClick={(e) => { e.preventDefault(); scrollToSection('bitrix'); }} 
            className="block text-[#162840]/80 hover:text-[#72BF3B] transition-colors cursor-pointer font-medium py-2"
          >
            Bitrix24
          </a>
          <a 
            href="#contact" 
            onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} 
            className="block bg-[#72BF3B] text-white px-6 py-3 rounded-xl hover:bg-[#99D93B] transition-all text-center cursor-pointer font-semibold whitespace-nowrap"
          >
            Fale Conosco
          </a>
        </div>
      </div>
    </nav>
  );
}
